import { Data, Modal, UI, Utils } from 'common';
import React from 'react';
import { getUserType } from '../../utils/userType';

const { Modal: ModalComponent } = Modal;
const { FeatureTile } = UI;
const { Analytics } = Utils;
const { SegmentEventTypes } = Data;

// Video Modal Component
const VideoModal = ({
	data: { videoId, title },
	modalId,
}: {
	data: { videoId: string; title: string };
	modalId: number;
}) => (
	<ModalComponent
		modalId={modalId}
		className="video-modal"
		header={title}
		size="large"
		hideFooter={true}
	>
		<div className="video-modal-content">
			<div className="video-container">
				<iframe
					width="100%"
					height="400"
					src={`https://www.youtube.com/embed/${videoId}`}
					title={title}
					allowFullScreen
				></iframe>
			</div>
		</div>
	</ModalComponent>
);

// Example usage of the Card component
const Videos = ({ modalContext }: { modalContext: any }) => {
	const { showModal } = modalContext || {};

	const handleCardClick = (videoId: string, title: string) => () => {
		// Open modal with YouTube video
		showModal({
			component: VideoModal,
			data: { videoId, title },
		});

		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'tile',
				field_name: videoId,
			},
			eventType: SegmentEventTypes.UserInteraction,
		});
	};

	const consumerCards = [
		{
			id: 'print-netstamp-sheets',
			headline: 'Print NetStamps® for letters and flats.',
			description:
				'Print any amount of First Class Mail® postage on blank labels to create your own stamps.',
			icon: 'Stamp',
			onClick: handleCardClick(
				'ZVmPoehI2m4',
				'Print NetStamps® for letters and flats.'
			),
		},
		{
			id: 'print-postage-envelopes',
			headline: 'Print addresses and postage on envelopes.',
			description:
				'Save on address labels and print discounted stamps on any type of envelope.',
			icon: 'Email',
			onClick: handleCardClick(
				'-R32ELt5VPU',
				'Print addresses and postage on envelopes.'
			),
		},
		{
			id: 'print-shipping-return-labels',
			headline: 'Create shipping and return labels.',
			description:
				"Print on plain paper, any adhesive label format, or create QR codes when you're on the go.",
			icon: 'Label01',
			onClick: handleCardClick(
				'hrfWcWnghFw',
				'Create shipping and return labels.'
			),
		},
		{
			id: 'history-page',
			headline: 'Track and manage everything you send.',
			description:
				'Get familiar with your history page where you can reprint, track items, create return labels, and more.',
			icon: 'Clock01',
			onClick: handleCardClick(
				'BHNTIlMrH0Q',
				'Track and manage everything you send.'
			),
		},
	];

	const businessCards = [
		{
			id: 'business-netstamp-sheets',
			headline: 'Print NetStamps® for letters and flats.',
			description:
				'Print any amount of First Class Mail® postage on blank labels to create your own stamps.',
			icon: 'Stamp  ',
			onClick: handleCardClick(
				'ZVmPoehI2m4',
				'Print NetStamps® for letters and flats.'
			),
		},
		{
			id: 'business-postage-envelopes',
			headline: 'Print addresses and postage on envelopes.',
			description:
				'Save on address labels and print discounted stamps on any type of envelope.',
			icon: 'Email',
			onClick: handleCardClick(
				'-R32ELt5VPU',
				'Print addresses and postage on envelopes.'
			),
		},
		{
			id: 'business-shipping-return-labels',
			headline: 'Create shipping and return labels.',
			description:
				"Print on plain paper, any adhesive label format, or create QR codes when you're on the go.",
			icon: 'Label01',
			onClick: handleCardClick(
				'hrfWcWnghFw',
				'Create shipping and return labels.'
			),
		},
		{
			id: 'business-certified-mail',
			headline: 'Get proof of delivery for your documents.',
			description:
				'Send Certified Mail®, Registered Mail® and request electronic return receipts or restrict delivery.',
			icon: 'DocumentApproved',
			onClick: handleCardClick(
				'pF7LrgsETL8',
				'Get proof of delivery for your documents.'
			),
		},
	];

	// Get the appropriate cards based on user type
	const userType = getUserType();
	const cards = userType === 'business' ? businessCards : consumerCards;

	return (
		<div className="home-videos-and-features-cards">
			{cards.map(card => (
				<FeatureTile key={card.headline} {...card} />
			))}
		</div>
	);
};

export default Videos;
